import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]
  static values = {
    storageKey: String,
    defaultOpen: { type: Boolean, default: false }
  }

  connect() {
    this.handleShown = () => this.remember(true)
    this.handleHidden = () => this.remember(false)

    this.contentTarget.addEventListener("shown.bs.collapse", this.handleShown)
    this.contentTarget.addEventListener("hidden.bs.collapse", this.handleHidden)

    const collapse = window.bootstrap.Collapse.getOrCreateInstance(this.contentTarget, { toggle: false })
    this.preferredOpenState() ? collapse.show() : collapse.hide()
  }

  disconnect() {
    this.contentTarget.removeEventListener("shown.bs.collapse", this.handleShown)
    this.contentTarget.removeEventListener("hidden.bs.collapse", this.handleHidden)
  }

  preferredOpenState() {
    try {
      const stored = window.localStorage.getItem(this.storageKeyValue)
      return stored === null ? this.defaultOpenValue : stored === "open"
    } catch {
      return this.defaultOpenValue
    }
  }

  remember(open) {
    this.toggleTarget.classList.toggle("collapsed", !open)
    this.toggleTarget.setAttribute("aria-expanded", String(open))

    try {
      window.localStorage.setItem(this.storageKeyValue, open ? "open" : "closed")
    } catch {
      // The collapse still works when storage is unavailable.
    }
  }
}
